import {ProgressHeaderWithPopup} from "../components/progressHeaderWithPopup";
import { HeadLogo } from "../components/headLogo";
import { GameIntroHeader } from "../components/gameIntroHeader";
import { CheckMoreButtons } from "../components/checkMoreButtons";
import { ModeIndication } from "../components/modeIndication";
import {LocationImageDisplay} from "../components/locationImageDisplay";

function SpeechBubbleView({
  mode,
  title,
  location,
  question,
  comment,
  onAnswer,
  images,
  onComplete,
  isChecked,
  currentStep,
  userInputValue,
  inputValue,
  onInputChange,
  questImageKey,
  loading,
  imageKey,
}) {





  return (
    <div className="speechbubble-layout">
      <HeadLogo />
      <ProgressHeaderWithPopup currentStep={currentStep}  title={title}  />
      <ModeIndication mode={mode} />
      <div className="speechbubble-content">
      <GameIntroHeader
          title="Speech Bubble"
          description={""}
        />
       <div className="askAI-infoContent">
          <div className="speechbubble-image-container">
            {images[questImageKey] && (
              <img
                src={images[questImageKey]}
                alt={location.title}
                className="speechbubble-image"
              />
            )}
          </div>
         <div className="speechbubble-question"> {question}</div>
         {!isChecked ? (
           <textarea
           className="speechbubble-input"
           placeholder="Type your response here..."
           value={inputValue}
          onChange={onInputChange}
         />
        ) : (
          <div className="speechbubble-userInputValue">
            {userInputValue}
          </div>
        )}
         

          <div className="speechbubble-buttons">
            
            {!isChecked ? (
          <div>
           <button className="checkmore-btn" id="speechbubble-answer" onClick={() => onAnswer(inputValue)}>
              Answer
            </button>
          </div>
        ) : (
          <CheckMoreButtons onNext={onComplete} />
        )}
        </div>
        
       
      </div>
      {isChecked && (
          <div
          id="comments-section"
          className="speechbubble-comments"
        >
         {loading ? (
      <div className="speechbubble-feedback">
        <div className="dot-typing"></div>
      </div>
    ) : (
      <div id="feedback" className="speechbubble-feedback">{comment}</div>
    )}
        </div>
        )}

</div>
         <LocationImageDisplay imageKey={imageKey} dynamicHeight="40vh" />
    </div>
  );
}

export { SpeechBubbleView };
